import LOGO from "../../PFC_Images/PFC46.png";
import CATALOG from "../../PFC_Images/Catalog.JPG"

const GolfTwo = () => {
    return (
        <div className="w-full h-full relative bg-black text-black">
            
            <img
                src={CATALOG}
                alt="background"
                className={`absolute duration-1000 opacity-70 inset-0 w-full h-full object-cover`}
            />
            
            <img
                src={LOGO}
                alt="background"
                className={`z-50 absolute top-2 left-2 size-24 inset-0 object-cover`}
            />
            
            <div className={`z-50 w-full h-full flex items-center justify-center`}>
                
                <div className={`z-50 w-2/3 flex flex-col backdrop-blur-sm p-4 rounded-2xl drop-shadow-2xl`}>
                    
                    <span className={`text-2xl flex flex-col font-bold text-white`}>
                        <span className={``}>A Complete Catalog</span>
                        <span className={``}>Built for Every Application</span>
                    </span>
                    <span className={`mt-3 text-sm text-gray-200 italic`}>Plant Food Company offers an extensive lineup of liquid fertilizers and turf solutions designed to meet the needs of any program. From essential nutrients to specialized formulations, our catalog gives you the flexibility to build precise, effective applications with confidence.</span>
                </div>
            
            </div>
            
        
        </div>
    )
}

export default GolfTwo;
